"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
class Format {
    static setUserName(email) {
        if (_.isNil(email) || email == "")
            return email;
        const userName = email.split("@")[0].split(".");
        const firstName = Format.capitalizeFirstLetter(userName[0]);
        const lastName = userName[1] ? Format.capitalizeFirstLetter(userName[1]) : "";
        return firstName + (lastName ? " " + lastName : "");
    }
    static capitalizeFirstLetter(text) {
        if (!text || text.length === 0)
            return text;
        return text.charAt(0).toUpperCase() + text.slice(1);
    }
}
exports.Format = Format;
//# sourceMappingURL=format.js.map